export default {
  outputList: [],
}
